import { Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';

export type BaseDropdownColors =
  | 'dark'
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'outline-danger'
  | 'outline-success'
  | 'outline-warning';

@Component({
  selector: 'base-action-dropdown',
  templateUrl: './base-action-dropdown.component.html',
})
/**
 * Simple dropdown for selections that perform an action afterwards<br/>
 * Not usable as a FormControl<br/>
 * ###Do not use for other purposes!<br/>
 * Available inputs: <br/>
 * - label (required)
 * - color (required)
 * - items (required)
 * - listItemClicked (required)
 *  <br/>
 *  Please see description of each input to read about usage information
 */
export class BaseActionDropdownComponent implements OnInit {
  @ViewChild('dropdownElement') dropdownElement: ElementRef;
  isOpen = false;
  shouldOpenUpward = false;
  /**
   * Adds a specific label inside dropdown select
   */
  @Input() label: string;
  /**
   * Defines color of dropdown-button based on BaseDropdownColors <br/>
   * Please check if btn-{{BaseDropdownColor}} exists in css before you add another color <br/>
   * Available colors:
   * - dark
   * - primary
   * - secondary
   * - outline-danger
   * - outline-success
   */
  @Input() color: BaseDropdownColors;
  /**
   * Register translations strings to component <br/>
   * e.g.: ['action.close', 'action.publish']
   */
  @Input() items: string[];
  /**
   * Adjusts dropdown paddings to allow usage of component on a limited space
   */
  @Input() smallPadding: boolean = false;
  /**
   * Make dropdown disabled
   */
  @Input() disabled: boolean = false;
  /**
   * Round dropdown button without a label
   */
  @Input() iconOnly: boolean = false;
  /**
   * Previously provided translation string will be emitted for item that has been clicked <br/>
   * e.g.: 'action.close'
   * you can react to this translation string to specify the action that needs to be performed afterwards
   */
  @Output() listItemClicked = new EventEmitter<string>();

  @HostBinding('class') class = 'dialog-dropdown';

  ngOnInit() {
    if (this.label === 'action.export') {
      this.class = 'export-dropdown';
    }
  }

  toggle(): void {
    const rect = this.dropdownElement.nativeElement.getBoundingClientRect();
    this.shouldOpenUpward = rect.bottom > window.innerHeight;
    this.isOpen = !this.isOpen;
  }

  onClickListItem(event: string) {
    this.listItemClicked.emit(event);
  }
}
